import { Component } from "react";
import { withRouter } from "react-router";
import PropTypes from "prop-types";
class ScrollToTop extends Component {
    componentDidUpdate(prevProps) {
        if (this.props.location.pathname !== prevProps.location.pathname) {
            window.scrollTo(0, 0);
        }
    }
    render() {
        return this.props.children;
    }
}
ScrollToTop.propTypes = {
    children: PropTypes.node,
    location: PropTypes.shape({
        hash: PropTypes.string,
        key: PropTypes.string,
        pathname: PropTypes.string,
        search: PropTypes.string,
    }),
};
export default withRouter(ScrollToTop);
